import { Injectable } from '@angular/core';
import { loginHelpScreenView } from '@com-delta-idp/mnx-login-ui';
import { BehaviorSubject } from 'rxjs';
import { LoginHelpScreenAdapterService } from '../../adapters/login-help-screen-adapter/login-help-screen-adapter.service';
import { LoginModalContent } from '../../models/aem';
import { LoginContentService } from '../../services/login-content.service';

@Injectable({
  providedIn: 'root'
})
export class LoginHelpScreenFacadeService {
  pageContent$ = new BehaviorSubject<loginHelpScreenView | undefined>(
    undefined
  );

  aemContent!: LoginModalContent;

  constructor(
    private loginContentService: LoginContentService,
    private loginHelpScreenAdapterService: LoginHelpScreenAdapterService
  ) {
    this.getLoginHelpScreenContent();
  }

  getLoginHelpScreenContent() {
    this.loginContentService.getAEMContent().subscribe((response) => {
      this.aemContent = response;
      this.pageContent$.next(
        this.loginHelpScreenAdapterService.getLoginHelpScreenContent(
          this.aemContent
        )
      );
    });
  }
}
